"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationSlice = notificationSlice;
const notificationInitialState = {
    notification: {
        alerts: [],
    },
};
function notificationSlice(set) {
    return {
        ...notificationInitialState,
        setNotification(alerts) {
            set((state) => {
                state.notification.alerts = alerts;
                return state;
            }, false, '[setNotification]');
        },
    };
}
